import { createEvent, h, Host, attachShadow, proxyCustomElement } from '@stencil/core/internal/client';
export { setAssetPath, setPlatformOptions } from '@stencil/core/internal/client';

const logonequi01Svg = 'data:image/svg+xml;base64,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';

const gnxNequiCss = ".gnx_nequi_title{text-align:center;align-self:flex-start}.gnx_nequi_message{border:1px solid #eb4a5a !important;border-radius:5px;background-color:#ff949ffa;color:#ffff}.my-custom-class{--background:#e5e5e5}.inputphone{text-align:left !important;padding-right:30%;display:block !important}.sc-ion-input-ios-h{width:60% !important}.card_nequi{margin-left:10% !important;margin-right:10% !important}.gnx_nequi_img{width:40% !important;height:40% !important;display:block !important;margin:0 auto !important;margin-left:auto !important;margin-right:auto !important}.row_svg{width:260px !important;display:block !important;margin:0 auto !important;margin-left:auto !important;margin-right:auto !important}";

const GnxNequi$1 = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.alerta = createEvent(this, "alerta", 7);
  }
  //transform value 
  transform(value) {
    value = value + ''; // make sure it's a string
    let prefix = '';
    if (value == undefined || value == '') {
      return prefix + '0';
    }
    return prefix + value.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  async componentWillLoad() {
    const { uid } = this.getUid;
    const { apiKey, appId } = this.dataCredentials;
    setTimeout(() => {
      console.log('phoneUserWC wc =', this.phoneUserWC);
    }, 8000);
    this.disabledButton = true;
    this.appId = appId;
    this.apiKey = apiKey;
    this.uid = uid;
    this.programId = this.programIdFWC;
    this.companyId = this.companyIdFWC;
    this.dataCP = {
      programId: this.programId,
      companyId: this.companyId
    };
    try {
      fetch(`${this.baseUrl}/nequi/info/${this.uid}?key=${this.apiKey}`, {
        method: 'POST',
        headers: new Headers({
          'Authorization': 'Bearer ' + this.getToken,
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify(this.dataCP)
      })
        .then((response) => response.json())
        .then(response => {
        console.log('Response == ', response);
        this.data = response;
        console.log(this.data);
        this.show = true;
        this.maxTransferCents = this.data.maxTransferCents;
        this.minTransferCents = this.data.minTransferCents;
        this.maxValueRedeem = this.data.maxValueRedeem;
        this.enable = this.data.enabled;
        this.enabledstatus = this.enable;
        this.max = Math.round(this.maxTransferCents / 100);
        this.min = Math.round(this.minTransferCents / 100);
        this.maxVRedem = Math.round(this.maxValueRedeem / 100);
        this.maxFloat = this.transform(this.max);
        this.minFloat = this.transform(this.min);
        this.maxVRedemFloat = this.transform(this.maxVRedem);
      });
    }
    catch (err) {
      console.log('err ==', err);
      if (err) {
        this.disabledButton = true;
        this.alertMsg = {
          header: 'Alerta',
          subHeader: 'Nequi',
          message: 'En el momento el modulo de nequi se encuentra inactivo y no podrá realizar recarga por favor espera a que el servicio se restablezca Gracias.'
        };
        this.alerta.emit(this.alertMsg);
      }
    }
  }
  handleSubmit(e) {
    e.preventDefault();
    if (e) {
      this.disabledButton = true;
    }
    this.valueMoney = this.value * 100;
    if (this.enabledstatus == false) {
      this.alertMsg = {
        header: 'Alerta',
        subHeader: 'NEQUI',
        message: 'En el momento el modulo de NEQUI se encuentra inactivo y no podrá realizar recarga por favor espera a que el servicio se restablezca Gracias.'
      };
      this.alerta.emit(this.alertMsg);
    }
    else if (this.enabledstatus == undefined) {
      this.alertMsg = {
        header: 'Alerta',
        subHeader: 'NEQUI',
        message: 'En el momento el modulo de NEQUI se encuentra inactivo y no podrá realizar recarga por favor espera a que el servicio se restablezca Gracias.'
      };
      e.target.reset();
      this.alerta.emit(this.alertMsg);
    }
    else if (this.valueMoney > this.maxTransferCents) {
      this.alertMsg = {
        header: 'Alerta',
        subHeader: 'Valores incorrectos',
        message: 'El valor supera la cantidad máxima de: $' + this.maxFloat
      };
      e.target.reset();
      this.alerta.emit(this.alertMsg);
    }
    else if (this.valueMoney > this.maxValueRedeem) {
      this.alertMsg = {
        header: 'Alerta',
        subHeader: 'Valores incorrectos',
        message: 'El valor debe ser  mínimo de: $' + this.maxVRedemFloat + ' que son sus puntos asignados'
      };
      e.target.reset();
      this.alerta.emit(this.alertMsg);
    }
    else if (this.valueMoney < this.minTransferCents) {
      this.alertMsg = {
        header: 'Alerta',
        subHeader: 'Valores incorrectos',
        message: 'El valor debe ser mayor de: $' + this.minFloat
      };
      e.target.reset();
      this.valueMoney = 0;
      this.alerta.emit(this.alertMsg);
    }
    else {
      const { name, lastName, docNumber, phone, email, document } = this.dataUser;
      this.userName = name;
      this.userlastname = lastName;
      this.userDocId = docNumber,
        this.userEmail = email;
      this.usernameN = document;
      this.nequiPhoneNumber = phone;
      this.sku = 'nequi';
      this.dataOrdersNequi = {
        uid: this.uid,
        sku: this.sku,
        quantity: 1,
        companyId: this.companyId,
        programId: this.programId,
        appId: this.appId,
        user: {
          name: this.userName,
          lastname: this.userlastname,
          docId: this.userDocId,
          email: this.userEmail,
          username: this.usernameN,
        },
        nequi: {
          phoneNumber: this.nequiPhoneNumber,
          sendValue: this.valueMoney
        }
      };
      try {
        fetch(`${this.baseUrl}/user-orders/${this.uid}?key=${this.apiKey}`, {
          method: 'POST',
          headers: new Headers({
            'Authorization': 'Bearer ' + this.getToken,
            'Content-Type': 'application/json'
          }),
          body: JSON.stringify(this.dataOrdersNequi)
        })
          .then((response) => response.json())
          .then(response => {
          console.log('response == ', response);
          console.log('Response == ', Response);
          console.log('data order nequi', this.dataOrdersNequi);
          if (response.code == 'VALIDATION_ERROR') {
            this.alertMsg = {
              header: 'Alerta',
              subHeader: 'Error en la orden',
              message: 'Los datos de la orden son incorrectos'
              //subHeader: response.code, 
              //message: response.message 
            };
            this.alerta.emit(this.alertMsg);
          }
          else if (response.code == 'created') {
            this.alertMsg = {
              header: 'Alerta',
              subHeader: 'Orden enviada',
              message: 'Listo! Tu recarga está en proceso, te llegará un SMS cuando esta sea confirmada'
              // subHeader: response.code, 
              // message: response.message 
            };
            this.alerta.emit(this.alertMsg);
          }
          else {
            this.alertMsg = {
              header: 'Alerta',
              subHeader: 'Error en la orden',
              message: 'Error en la orden'
              //subHeader: response.code, 
              //message: response.message 
            };
            this.alerta.emit(this.alertMsg);
          }
        });
      }
      catch (error) {
        console.log(error);
        this.alertMsg = {
          header: 'Alerta',
          subHeader: 'Error',
          message: 'Ocurrio un error en la orden'
          // subHeader: response.code, 
          // message: response.message 
        };
        this.alerta.emit(this.alertMsg);
      }
      setTimeout(() => {
        this.componentWillLoad();
      }, 6000);
    }
    e.target.reset();
  }
  handleChange(event) {
    this.value = event.target.value;
    console.log(this.value);
    if (this.value >= 1000) {
      this.disabledButton = false;
    }
    else {
      this.disabledButton = true;
    }
  }
  enableddoubleclik(e) {
    if (e) {
      this.disabledButton = true;
      console.log('disabled button =', this.disabledButton);
    }
  }
  render() {
    return (h(Host, null, h("ion-card", { class: "card_nequi" }, h("ion-card-content", null, h("ion-grid", null, h("form", { onSubmit: (e) => this.handleSubmit(e) }, h("ion-row", null, h("ion-col", null, h("h1", { class: "gnx_nequi_title" }, 'Recarga NEQUI'))), h("ion-row", { class: "row_svg" }, h("ion-img", { class: "gnx_nequi_img", src: logonequi01Svg })), this.enable ? ('') : (h("ion-row", null, h("ion-col", { class: "gnx_nequi_message" }, h("h2", null, 'En el momento el modulo de nequi se encuentra inactivo y no podrá realizar ninguna recarga por favor esperar a que el servicio se restablezca Gracias.')))), h("ion-row", null, h("ion-col", null, this.show ? (h("h2", null, 'Usted puede redimir hasta $', " ", this.maxVRedemFloat, " ", 'con los puntos que tiene')) : (h("h2", null, '')))), h("ion-row", null, h("ion-col", { class: "gnx_nequi_message" }, h("h3", null, " ", 'El número de celular debe tener cuenta en NEQUI asociado a su número de documento.'))), h("ion-row", null, h("ion-col", null, h("h3", null, 'Cuando envíes la recarga la orden entrará en proceso, te llegará un SMS cuando esta sea confirmada.'))), h("ion-row", null, h("ion-col", null, h("ion-item", null, h("ion-label", { position: "stacked" }, 'Número de celular'), h("ion-input", { class: "inputphone", disabled: "true" }, this.phoneUserWC)))), h("ion-row", null, h("ion-col", null, h("ion-item", null, h("ion-label", { position: "stacked" }, 'Cantidad de dinero'), h("ion-input", { type: "number", formControlName: "cash", min: "1000", max: "10000000", value: this.value, onInput: (event) => this.handleChange(event) })))), h("ion-row", null, h("ion-col", null, this.show ? (h("h2", null, 'La recarga mínima es de $', " ", this.minFloat, " ", ' y máxima mensual es de $', " ", this.maxFloat, " ")) :
      (h("h2", null, '')))), h("ion-button", { expand: "block", shape: "round", class: "submit_nequi", type: "submit", value: "Submit", disabled: this.disabledButton }, h("ion-label", null, 'Enviar'))))))));
  }
  static get style() { return gnxNequiCss; }
};

function format(first, middle, last) {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

const myComponentCss = ":host{display:block}.gnx_nequi_title{text-align:center;align-self:flex-start}";

const MyComponent$1 = class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    attachShadow(this);
  }
  getText() {
    return format(this.first, this.middle, this.last);
  }
  render() {
    return h("div", null, "Hello, World! I'm ", this.getText());
  }
  static get style() { return myComponentCss; }
};

const GnxNequi = /*@__PURE__*/proxyCustomElement(GnxNequi$1, [0,"gnx-nequi",{"getToken":[8,"get-token"],"getUid":[8,"get-uid"],"dataUser":[8,"data-user"],"phoneUserWC":[8,"phone-user-w-c"],"baseUrl":[8,"base-url"],"dataCredentials":[8,"data-credentials"],"programIdFWC":[8,"program-id-f-w-c"],"companyIdFWC":[8,"company-id-f-w-c"],"disabledButton":[4,"disabled-button"],"show":[32],"value":[32],"maxTransferCents":[32],"minTransferCents":[32],"maxValueRedeem":[32],"enable":[32],"data":[32],"alertMsg":[32]}]);
const MyComponent = /*@__PURE__*/proxyCustomElement(MyComponent$1, [1,"my-component",{"first":[1],"middle":[1],"last":[1]}]);
const defineCustomElements = (opts) => {
  if (typeof customElements !== 'undefined') {
    [
      GnxNequi,
  MyComponent
    ].forEach(cmp => {
      if (!customElements.get(cmp.is)) {
        customElements.define(cmp.is, cmp, opts);
      }
    });
  }
};

export { GnxNequi, MyComponent, defineCustomElements };
